import React, { useState } from "react";

import {
    Box,
    Typography,
    Button,
    Card,
    CardMedia,
    CardContent,
    Chip,
    Stack,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { motion } from "framer-motion";

import CrearNoticia from "../../components/Admin/News/CrearNoticia";
import EditarNoticia from "../../components/Admin/News/EditarNoticia";
import EliminarNoticia from "../../components/Admin/News/EliminarNoticia";
import useNoticias from "../../hooks/useNoticias";
import StatusModal from "../../utils/StatusModal";

const aparecer = {
    hidden: {
        opacity: 0,
        y: 30,
    },

    visible: (i = 0) => ({
        opacity: 1,
        y: 0,

        transition: {
            delay: i * 0.08,
            duration: 0.5,
        },
    }),
};


export const Noticias = () => {

    const [modo, setModo] = useState("lista");
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const [noticiaSeleccionada, setNoticiaSeleccionada] =
        useState(null);

    const {
        noticias,
        loading,
        error,
        crearNoticia,
        actualizarNoticia,
        eliminarNoticia,
    } = useNoticias();

    const [statusModal, setStatusModal] = useState({
    open: false,
    status: "loading",
    title: "",
    message: "",
});

const mostrarModal = ({
    status,
    title,
    message,
}) => {
    setStatusModal({
        open: true,
        status,
        title,
        message,
    });
};

const cerrarModal = () => {
    setStatusModal((prev) => ({
        ...prev,
        open: false,
    }));
};

    // CREAR

    const handleCrear = () => {
        setNoticiaSeleccionada(null);
        setModo("crear");
        
    };


    // EDITAR

    const handleEditar = (noticia) => {
        setNoticiaSeleccionada(noticia);
        setModo("editar");
    };


    // ELIMINAR

    const handleEliminar = (noticia) => {
        setNoticiaSeleccionada(noticia);
        setModo("eliminar");
    };


    // VOLVER

    const handleVolver = () => {
        setModo("lista");
        setNoticiaSeleccionada(null);
    };


    // GUARDAR

 const handleGuardar = async (formData) => {

    

    mostrarModal({
        status: "loading",
        title: "Creando noticia",
        message: "Estamos guardando la noticia. Por favor espera...",
    });

    try {

        const resultado = await crearNoticia(formData);

       
        mostrarModal({
            status: "success",
            title: "¡Noticia creada!",
            message: "La noticia se ha creado correctamente.",
        });

        setTimeout(() => {

            setModo("lista");
            setNoticiaSeleccionada(null);
            cerrarModal();

        }, 1800);

    } catch (error) {

        console.error(
            "ERROR CREANDO NOTICIA:",
            error
        );

        mostrarModal({
            status: "error",
            title: "No se pudo crear la noticia",
            message:
                error?.response?.data?.message ||
                "Ocurrió un problema al intentar crear la noticia.",
        });
    }
};


    // ACTUALIZAR

  const handleActualizar = async (noticiaActualizada) => {

    mostrarModal({
        status: "loading",
        title: "Actualizando noticia",
        message: "Estamos guardando los cambios. Por favor espera...",
    });

    try {

        const resultado = await actualizarNoticia(
            noticiaActualizada.id,
            noticiaActualizada.formData
        );

        if (resultado) {

            mostrarModal({
                status: "success",
                title: "¡Noticia actualizada!",
                message: "Los cambios se guardaron correctamente.",
            });

            setTimeout(() => {
                setModo("lista");
                setNoticiaSeleccionada(null);
                cerrarModal();
            }, 1800);
        }

    } catch (error) {

        console.error(
            "Error al actualizar noticia:",
            error
        );

        mostrarModal({
            status: "error",
            title: "Error al actualizar",
            message:
                error?.response?.data?.message ||
                "Ocurrió un problema al actualizar la noticia.",
        });
    }
};


    // ELIMINAR

   const handleConfirmarEliminar = async (id) => {
    mostrarModal({
        status: "loading",
        title: "Eliminando noticia",
        message: "Estamos eliminando la noticia. Por favor espera...",
    });

    try {
        const resultado = await eliminarNoticia(id);

        if (!resultado) {
            throw new Error("No se pudo eliminar la noticia.");
        }

        mostrarModal({
            status: "success",
            title: "¡Noticia eliminada!",
            message: "La noticia se eliminó correctamente.",
        });

        setTimeout(() => {
            setModo("lista");
            setNoticiaSeleccionada(null);
            cerrarModal();
        }, 1800);

    } catch (error) {
        console.error("Error al eliminar noticia:", error);

        mostrarModal({
            status: "error",
            title: "Error al eliminar",
            message:
                error?.response?.data?.message ||
                error?.message ||
                "Ocurrió un problema al eliminar la noticia.",
        });
    }
};;



 // CREAR

if (modo === "crear") {

    return (
        <>
            <CrearNoticia
                onVolver={handleVolver}
                onGuardar={handleGuardar}
            />

            <StatusModal
                open={statusModal.open}
                status={statusModal.status}
                title={statusModal.title}
                message={statusModal.message}
                onClose={cerrarModal}
            />
        </>
    );
}

    // EDITAR

   if (modo === "editar") {
    return (
        <>
            <EditarNoticia
                noticia={noticiaSeleccionada}
                onVolver={handleVolver}
                onActualizar={handleActualizar}
            />

            <StatusModal
                open={statusModal.open}
                status={statusModal.status}
                title={statusModal.title}
                message={statusModal.message}
                onClose={cerrarModal}
            />
        </>
    );
}

    // ELIMINAR

    if (modo === "eliminar") {
    return (
        <>
            <EliminarNoticia
                noticia={noticiaSeleccionada}
                onVolver={handleVolver}
                onEliminar={handleConfirmarEliminar}
            />

            <StatusModal
                open={statusModal.open}
                status={statusModal.status}
                title={statusModal.title}
                message={statusModal.message}
                onClose={cerrarModal}
            />
        </>
    );
}

    // LOADING

    if (loading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "300px",
                }}
            >
                <Typography>
                    Cargando noticias...
                </Typography>
            </Box>
        );
    }


    // ERROR

    if (error) {
        return (
            <Box sx={{ p: 3 }}>
                <Typography color="error">
                    {error}
                </Typography>
            </Box>
        );
    }
    

    return (

        <Box
            sx={{
                width: "100%",
                maxWidth: "1500px",
                mx: "auto",
                pb: 5,
            }}
        >

            {/* HEADER */}

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: {
                        xs: "flex-start",
                        md: "center",
                    },

                    flexDirection: {
                        xs: "column",
                        md: "row",
                    },

                    gap: 2,

                    mb: 4,
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                    }}
                >

                    <Box
                        sx={{
                            width: 52,
                            height: 52,

                            borderRadius: 2,

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            background:
                                "#EAF0F6",

                            color:
                                "#22324A",
                        }}
                    >

                        <NewspaperOutlinedIcon />

                    </Box>


                    <Box>

                        <Typography
                            sx={{
                                fontSize:
                                    "1.8rem",

                                fontWeight: 700,

                                color:
                                    "#22324A",
                            }}
                        >
                            Noticias
                        </Typography>


                        <Typography
                            sx={{
                                color:
                                    "#7A828D",

                                fontSize:
                                    "0.9rem",
                            }}
                        >
                            Administra las noticias del Colegio Antilen
                        </Typography>

                    </Box>

                </Box>


                <Button
                    variant="contained"

                    startIcon={
                        <AddIcon />
                    }

                    onClick={
                        handleCrear
                    }

                    sx={{
                        background:
                            "#22324A",

                        borderRadius:
                            2,

                        textTransform:
                            "none",

                        fontWeight:
                            600,

                        px: 2.5,

                        py: 1.2,

                        "&:hover": {
                            background:
                                "#182536",
                        },
                    }}
                >
                    Crear noticia
                </Button>

            </Box>


            {/* RESUMEN */}

            <Box
                sx={{
                    display: "grid",

                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(3, 1fr)",
                    },

                    gap: 2,

                    mb: 4,
                }}
            >

                <Card
                    sx={{
                        borderRadius: 3,

                        border:
                            "1px solid #E7EAF0",

                        boxShadow:
                            "none",
                    }}
                >

                    <CardContent>

                        <Typography
                            sx={{
                                fontSize:
                                    "0.75rem",

                                color:
                                    "#7A828D",

                                fontWeight:
                                    600,
                            }}
                        >
                            TOTAL NOTICIAS
                        </Typography>


                        <Typography
                            sx={{
                                mt: 0.5,

                                fontSize:
                                    "1.8rem",

                                fontWeight:
                                    700,

                                color:
                                    "#22324A",
                            }}
                        >
                            {noticias.length}
                        </Typography>

                    </CardContent>

                </Card>


                <Card
                    sx={{
                        borderRadius: 3,

                        border:
                            "1px solid #E7EAF0",

                        boxShadow:
                            "none",
                    }}
                >

                    <CardContent>

                        <Typography
                            sx={{
                                fontSize:
                                    "0.75rem",

                                color:
                                    "#7A828D",

                                fontWeight:
                                    600,
                            }}
                        >
                            PUBLICADAS
                        </Typography>


                        <Typography
                            sx={{
                                mt: 0.5,

                                fontSize:
                                    "1.8rem",

                                fontWeight:
                                    700,

                                color:
                                    "#2E7D32",
                            }}
                        >
                            {
                                noticias.filter(
                                    (n) =>
                                        n.estado ===
                                        "Publicado"
                                ).length
                            }
                        </Typography>

                    </CardContent>

                </Card>


                <Card
                    sx={{
                        borderRadius: 3,

                        border:
                            "1px solid #E7EAF0",

                        boxShadow:
                            "none",
                    }}
                >

                    <CardContent>

                        <Typography
                            sx={{
                                fontSize:
                                    "0.75rem",

                                color:
                                    "#7A828D",

                                fontWeight:
                                    600,
                            }}
                        >
                            BORRADORES
                        </Typography>


                        <Typography
                            sx={{
                                mt: 0.5,

                                fontSize:
                                    "1.8rem",

                                fontWeight:
                                    700,

                                color:
                                    "#B7791F",
                            }}
                        >
                            {
                                noticias.filter(
                                    (n) =>
                                        n.estado ===
                                        "Borrador"
                                ).length
                            }
                        </Typography>

                    </CardContent>

                </Card>

            </Box>


            {/* GRID DE NOTICIAS */}

            <Box
                sx={{
                    display: "grid",

                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, 1fr)",
                        lg: "repeat(3, 1fr)",
                    },

                    gap: 3,
                }}
            >

                {noticias.map(
                    (noticia, index) => (

                        <motion.div

                            key={
                                noticia.id
                            }

                            variants={
                                aparecer
                            }

                            initial="hidden"

                            animate="visible"

                            custom={
                                index
                            }

                            style={{
                                height:
                                    "100%",
                            }}
                        >

                            <Card
                                elevation={0}

                                sx={{
                                    height:
                                        "100%",

                                    borderRadius:
                                        "24px",

                                    overflow:
                                        "hidden",

                                    background:
                                        "#fff",

                                    border:
                                        "1px solid #eef2f7",

                                    display:
                                        "flex",

                                    flexDirection:
                                        "column",

                                    transition:
                                        ".35s",

                                    "&:hover":
                                        {
                                            transform:
                                                "translateY(-6px)",

                                            boxShadow:
                                                "0px 18px 40px rgba(18,33,63,.10)",
                                        },

                                    "&:hover img":
                                        {
                                            transform:
                                                "scale(1.06)",
                                        },
                                }}
                            >

                                {/* IMAGEN */}

                                <Box
                                    sx={{
                                        overflow:
                                            "hidden",

                                        position:
                                            "relative",
                                    }}
                                >

                                    <CardMedia
                                        component="img"

                                        src={`${backendURL}/${noticia.img1}`}

                                        alt={
                                            noticia.titulo
                                        }

                                        sx={{
                                            height: {
                                                xs: 210,
                                                md: 230,
                                            },

                                            objectFit:
                                                "cover",

                                            transition:
                                                ".5s",
                                        }}
                                    />


                                    {/* TIPO */}

                                    <Chip
                                        label={
                                            noticia.tipo
                                        }

                                        sx={{
                                            position:
                                                "absolute",

                                            left: 18,

                                            top: 18,

                                            background:
                                                "linear-gradient(135deg,#C62828,#8f1515)",

                                            color:
                                                "#fff",

                                            fontWeight:
                                                700,

                                            borderRadius:
                                                "30px",

                                            textTransform:
                                                "capitalize",
                                        }}
                                    />


                                    {/* ESTADO */}

                                    <Chip
                                        label={
                                            noticia.estado
                                        }

                                        size="small"

                                        sx={{
                                            position:
                                                "absolute",

                                            right: 18,

                                            top: 18,

                                            backgroundColor:
                                                noticia.estado ===
                                                "Publicado"
                                                    ? "#E8F5EC"
                                                    : "#FFF4DD",

                                            color:
                                                noticia.estado ===
                                                "Publicado"
                                                    ? "#367047"
                                                    : "#956B20",

                                            fontWeight:
                                                700,

                                            backdropFilter:
                                                "blur(5px)",
                                        }}
                                    />

                                </Box>


                                {/* CONTENIDO */}

                                <CardContent
                                    sx={{
                                        p: 3,

                                        display:
                                            "flex",

                                        flexDirection:
                                            "column",

                                        flex: 1,
                                    }}
                                >

                                    {/* FECHA */}

                                    <Stack
                                        direction="row"

                                        spacing={1}

                                        alignItems="center"
                                    >

                                        <CalendarMonthOutlinedIcon
                                            sx={{
                                                color:
                                                    "#C62828",

                                                fontSize:
                                                    19,
                                            }}
                                        />


                                        <Typography
                                            sx={{
                                                color:
                                                    "#6B7280",

                                                fontSize:
                                                    14,
                                            }}
                                        >
                                            {
                                                noticia.fecha
                                            }
                                        </Typography>

                                    </Stack>


                                    {/* TITULO */}

                                    <Typography
                                        sx={{
                                            mt: 1.5,

                                            color:
                                                "#12213F",

                                            fontWeight:
                                                700,

                                            fontSize:
                                                "1.35rem",

                                            fontFamily:
                                                "Archivo",

                                            lineHeight:
                                                1.25,

                                            display:
                                                "-webkit-box",

                                            WebkitLineClamp:
                                                2,

                                            WebkitBoxOrient:
                                                "vertical",

                                            overflow:
                                                "hidden",
                                        }}
                                    >
                                        {
                                            noticia.titulo
                                        }
                                    </Typography>


                                    {/* DESCRIPCIÓN */}

                                    <Typography
                                        sx={{
                                            mt: 1.5,

                                            color:
                                                "#606C80",

                                            lineHeight:
                                                1.65,

                                            fontSize:
                                                "0.9rem",

                                            flex: 1,

                                            display:
                                                "-webkit-box",

                                            WebkitLineClamp:
                                                3,

                                            WebkitBoxOrient:
                                                "vertical",

                                            overflow:
                                                "hidden",
                                        }}
                                    >
                                        {
                                            noticia.descripcion
                                        }
                                    </Typography>


                                    {/* ACCIONES */}

                                    <Box
                                        sx={{
                                            display:
                                                "flex",

                                            justifyContent:
                                                "space-between",

                                            alignItems:
                                                "center",

                                            mt: 3,

                                            pt: 2,

                                            borderTop:
                                                "1px solid #EEF1F5",
                                        }}
                                    >

                                        <Button
                                            size="small"

                                            startIcon={
                                                <VisibilityOutlinedIcon />
                                            }

                                            sx={{
                                                color:
                                                    "#31516F",

                                                textTransform:
                                                    "none",

                                                fontWeight:
                                                    600,

                                                borderRadius:
                                                    2,
                                            }}
                                        >
                                            Ver
                                        </Button>


                                        <Box
                                            sx={{
                                                display:
                                                    "flex",

                                                gap:
                                                    0.5,
                                            }}
                                        >

                                            <Button
                                                size="small"

                                                startIcon={
                                                    <EditOutlinedIcon />
                                                }

                                                onClick={() =>
                                                    handleEditar(
                                                        noticia
                                                    )
                                                }

                                                sx={{
                                                    color:
                                                        "#31516F",

                                                    textTransform:
                                                        "none",

                                                    fontWeight:
                                                        600,

                                                    borderRadius:
                                                        2,

                                                    "&:hover":
                                                        {
                                                            background:
                                                                "#EEF3F8",
                                                        },
                                                }}
                                            >
                                                Editar
                                            </Button>


                                            <Button
                                                size="small"

                                                startIcon={
                                                    <DeleteIcon />
                                                }

                                                onClick={() =>
                                                    handleEliminar(
                                                        noticia
                                                    )
                                                }

                                                sx={{
                                                    color:
                                                        "#B13B3B",

                                                    textTransform:
                                                        "none",

                                                    fontWeight:
                                                        600,

                                                    borderRadius:
                                                        2,

                                                    "&:hover":
                                                        {
                                                            background:
                                                                "#FFF0F0",
                                                        },
                                                }}
                                            >
                                                Eliminar
                                            </Button>

                                        </Box>

                                    </Box>

                                </CardContent>

                            </Card>

                        </motion.div>

                    )
                )}

            </Box>

        </Box>
    );
};


export default Noticias;